"use client";

import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import useAuth from "@/contexts/auth-context";
import IServiceQueue from "@/interfaces/service-queue.interface";
import { ServiceQueueMessages } from "@/messages/service-queue/service-queue.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { ServiceQueueTableRow } from "./row";
import { SERVICE_QUEUE_TABLE_COLUMNS } from "../../constants";

interface ServiceQueueTableProps {
  data: PaginatedResponse<IServiceQueue>;
  pagination: Pagination;
  messages: ServiceQueueMessages;
}

export function ServiceQueueTable({ data, pagination, messages }: ServiceQueueTableProps) {
  const { pageNumber, pageSize, changePage, extend } = pagination;
  const { user: currentUser } = useAuth();
  const columns = SERVICE_QUEUE_TABLE_COLUMNS(messages);

  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {columns.map((label, index) => (
                <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {currentUser &&
              data.items.map((serviceQueue, index) => (
                <ServiceQueueTableRow
                  key={`${index} - ${serviceQueue.id}`}
                  index={index}
                  serviceQueue={serviceQueue}
                  messages={messages}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => extend(Number(e.target.value))}
        rowsPerPage={pageSize}
        page={pageNumber - 1}
        onPageChange={(_, pageNumber) => changePage(pageNumber)}
      />
    </>
  );
}
